import { render, staticRenderFns } from "./recommand.vue?vue&type=template&id=f80baddc&scoped=true"
import script from "./recommand.vue?vue&type=script&lang=js"
export * from "./recommand.vue?vue&type=script&lang=js"
import style0 from "./recommand.vue?vue&type=style&index=0&id=f80baddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80baddc",
  null
  
)

export default component.exports